import { useContext } from 'react'
import { DataContext } from './DataContext'

export const useDataContext = () => {
  const context = useContext(DataContext)

  if (context === undefined) {
    throw new Error('useDataContext must be used within DataContextProvider')
  }

  return context
}
